<template>
  <el-popover
    :visible="show"
    placement="top"
    trigger="click"
    popper-class="emoji_box"
  >
    <div class="emoji_body_div_box" v-click-outside="close">
      <div class="emoji_body_div">
        <VirtualScrollbar ref="virtualScrollbar">
          <div v-if="type == 1" class="emoji_body">
            <div v-for="(item, index) in emojiList" :key="index">
              <img
                class="icon_emoji"
                :src="item.url"
                alt=""
                :title="item.name"
                @click="selectEmoji(item.value)"
              />
            </div>
          </div>
          <div v-if="type == 2" class="emoji_body">
            <div
              v-for="(item, index) in emojiArr[currentIndex].emoji"
              :key="index"
            >
              <img
                class="icon_emoji2"
                :src="item.image"
                alt=""
                :title="item.title"
                @click="selectEmoji2(item)"
              />
            </div>
          </div>
        </VirtualScrollbar>
      </div>
      <div class="option_cells">
        <div
          class="option_cell"
          :class="{ option_cell_active: type == 1 }"
          @click.stop="changeType(1, null)"
        >
          <img src="@/assets/img/circleV2/icon_emoji.png" alt="" />
        </div>
        <div
          v-for="(item, index) in emojiArr"
          :key="index"
          class="option_cell"
          :class="{ option_cell_active: type == 2 && currentIndex == index }"
          @click.stop="changeType(2, index)"
        >
          <img :src="item.image" alt="" />
        </div>
      </div>
    </div>

    <template #reference>
      <div class="emoji_cell" @click="handleEmojiInit">
        <slot />
      </div>
    </template>
  </el-popover>
</template>

<script>
import request from "@/utils/request";
import emojiList from "@/utils/emoji";
import { ClickOutside as vClickOutside } from "element-plus";
export default {
  directives: {
    "click-outside": vClickOutside, // 局部注册指令
  },
  data() {
    return {
      type: 1,
      emojiList,
      show: false,
      currentIndex: null,
      emojiArr: [
        {
          id: 0,
          title: "",
          image: "",
          emoji: emojiList,
        },
      ],
    };
  },
  mounted() {
    this.getEmojiInfoList();
  },
  methods: {
    // selectEmoji (val) {
    //   if (this.id === 'public') {
    //     this.$emit('changeInput', val)
    //   } else if (this.id === 'private') {
    //     this.$emit('changeTextarea', val)
    //   }
    // },
    async getEmojiInfoList() {
      const res = await request.post("/api/emoji/infoList");
      this.emojiArr = res.data;
    },
    changeType(e, index) {
      this.currentIndex = index;
      this.type = e;
      // this.handleEmojiInit();
    },
    close() {
      this.show = false;
    },
    selectEmoji(val) {
      this.$emit("input", val);
      this.close();
    },
    selectEmoji2(val) {
      this.$emit("input2", val);
      this.close();
    },
    handleEmojiInit() {
      this.show = true;
      setTimeout(() => {
        this.$refs.virtualScrollbar.update();
        this.$refs.virtualScrollbar.setScrollTopVal(0);
      });
    },
  },
};
</script>

<style>
.emoji_box {
  width: auto !important;
  height: auto;
  padding: 0 !important;
  z-index: 99 !important;
  max-width: inherit !important;
}

.emoji_box .popper__arrow::after {
  /* border-bottom-color: rgba(0, 0, 0, 0.6) !important; */
}
</style>
<style scoped>
.emoji_body_div {
  width: 420px;
  height: 240px;
}

.emoji_body {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  box-sizing: border-box;
  padding: 10px;
}

.icon_emoji {
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: block;
}
.icon_emoji2 {
  width: 72px;
  height: 72px;
  cursor: pointer;
  display: block;
}
/* .emoji_cell {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.emoji_cell img {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 2px;
} */
.option_cells {
  width: 100%;
  height: 38px;
  background-color: #ebeef5;
  display: flex;
  border-radius: 0 0 4px 4px;
  overflow: hidden;
}

.option_cell {
  width: 48px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.option_cell img {
  width: 20px;
  height: 20px;
  display: block;
}

.option_cell_active {
  background-color: #fff;
}
</style>
